import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface NeoButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'neo';
  size?: 'small' | 'medium' | 'large';
  /** Present when the button renders an anchor. */
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
}

const NeoButton: React.FC<NeoButtonProps> = ({
  variant = 'secondary',
  size = 'medium',
  children,
  sx,
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return {
          background: "#5A5E73",
          color: "#FFFFFF",
          "&:hover": {
            background: "#4A4E63",
            boxShadow: "none",
          },
        };
      case 'secondary':
        return {
          background: "#F3F4FD",
          color: "#6C6C6C",
          "&:hover": {
            background: "#EDEFF5",
            boxShadow: "none",
          },
        };
      case 'neo':
        return {
          background: "#705D4A",
          color: "",
          "&:hover": {
            background: "#604D3A",
            boxShadow: "none",
          },
        };
      case 'ghost':
        return {
          background: "transparent",
          color: "#6C6C6C",
          border: "1px solid #E5E5E5",
          "&:hover": {
            background: "#F9F9F9",
            boxShadow: "none",
          },
        };
      default:
        return {};
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          px: 1,
          py: 0.5,
          fontSize: "12px",
        };
      case 'medium':
        return {
          px: 1,
          py: 1,
          fontSize: "14px",
        };
      case 'large':
        return {
          px: 2,
          py: 1.5,
          fontSize: "16px",
        };
      default:
        return {};
    }
  };

  const baseStyles = {
    padding: "8px 24px 8px 25px !important",
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: "var(--theo-font-sans)",
    textTransform: "none" as const,
    borderRadius: "6px",
    boxShadow: "none",
    minWidth: 0,
    whiteSpace: "nowrap" as const,
    disableElevation: true,
  };

  return (
    <Button
      variant="contained"
      sx={{
        ...baseStyles,
        ...getVariantStyles(),
        ...getSizeStyles(),
        ...sx,
      }}
      {...(props as ButtonProps)}
    >
      {children}
    </Button>
  );
};

export default NeoButton; 